import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Route, Switch, useHistory, useLocation, useParams } from 'react-router-dom';
import useSWR from 'swr';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { extractFromArray } from '../../../../utils';
import Button from '../../../common/base/Button';
import Loading from '../../../common/base/Loading';
import Tabs from '../../../common/base/Tabs';
import { useDialog } from '../../../common/Dialog';
import { Div } from '../../../common/helpers/StyledUtils';
import { useToasts } from '../../../common/Toast';
import { GlobalContext } from '../../../contexts/GlobalContext';
import useSearchQuery from '../../../hooks/useSearchQuery';
import ConfirmDeleteDialog from '../Connections/ConfirmDeleteDialog';
import TransformRuleFormWrapper from '../Connections/Forms/TransformRuleForm';
import { StyledViewNavActions, StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, ViewBreadcrumbsTitle } from '../../../layouts/ViewLayout';
import NotFound from '../NotFound';
import TransformationExecutionDetails from './TransformationExecutionDetails';
import { TransformationExecutions } from './TransformationExecutions';
import TransformationExecutionsView from './TransformationExecutionsView';
import { TransformationOverview } from './TransformationOverview';
import useTransformationExecutionsList from '../../../hooks/useTransformationExecutionsList';
interface Query {
  selected_execution_id?: string | string[];
  tab?: 'overview' | 'executions';
}
export const TransformationView: React.FC<{
  id?: string;
  mutate_transformations?: () => void;
}> = t0 => {
  const $ = _c(79);
  const {
    id,
    mutate_transformations
  } = t0;
  const {
    id: id_params
  } = useParams();
  const transformation_id = id || id_params;
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  let t1;
  if ($[0] !== query.selected_execution_id) {
    t1 = extractFromArray(query.selected_execution_id);
    $[0] = query.selected_execution_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selected_execution_id = t1 as string;
  const history = useHistory();
  const location = useLocation();
  const {
    addToast
  } = useToasts();
  const showDialog = useDialog();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t2;
  if ($[2] !== transformation_id) {
    t2 = APIMethodKeys.transformations.get(transformation_id);
    $[2] = transformation_id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== HookdeckAPI.transformations || $[5] !== transformation_id) {
    t3 = () => HookdeckAPI.transformations.get(transformation_id);
    $[4] = HookdeckAPI.transformations;
    $[5] = transformation_id;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: transformation,
    error
  } = useSWR(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {};
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    count,
    refresh
  } = useTransformationExecutionsList(transformation_id, t4);
  let t5;
  if ($[8] !== transformation_id) {
    t5 = APIMethodKeys.transformations.hasConnections(transformation_id);
    $[8] = transformation_id;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== HookdeckAPI.transformations || $[11] !== transformation_id) {
    t6 = () => HookdeckAPI.transformations.hasConnections(transformation_id);
    $[10] = HookdeckAPI.transformations;
    $[11] = transformation_id;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const {
    data: transformation_connections
  } = useSWR(t5, t6);
  const disable_delete = transformation_connections?.has_connections === undefined || !!transformation_connections?.has_connections;
  let t7;
  if ($[13] !== location.pathname) {
    t7 = location.pathname.endsWith("/executions");
    $[13] = location.pathname;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const is_executions_tab = t7;
  const current_tab = is_executions_tab ? "executions" : "overview";
  const t8 = `/transformations/${transformation_id}`;
  let t9;
  if ($[15] !== t8) {
    t9 = {
      label: "Overview",
      key: "overview",
      to: t8
    };
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = `/transformations/${transformation_id}/executions`;
  let t11;
  if ($[17] !== count || $[18] !== t10) {
    t11 = {
      label: "Executions",
      key: "executions",
      badge_label: count,
      badge_theme: "muted",
      to: t10
    };
    $[17] = count;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t9) {
    t12 = {
      OVERVIEW: t9,
      EXECUTIONS: t11
    };
    $[20] = t11;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const TABS = t12 as const;
  if (error && error.response?.status === 404) {
    let t13;
    if ($[23] !== transformation_id) {
      t13 = <NotFound title="Transformation not found" description="This transformation does not exist or has been deleted." id={transformation_id} />;
      $[23] = transformation_id;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    return t13;
  }
  if (!transformation) {
    let t13;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = {
        justify: "center"
      };
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    let t14;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <Div flex={t13} p={8}><Loading /></Div>;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    return t14;
  }
  let t13;
  if ($[27] !== HookdeckAPI.transformations || $[28] !== addToast || $[29] !== history || $[30] !== mutate_transformations || $[31] !== showDialog || $[32] !== transformation_id) {
    t13 = async () => {
      showDialog(() => HookdeckAPI.transformations.delete(transformation_id).then(() => {
        mutate_transformations?.();
        addToast("success", "Transformation deleted");
        history.push("/transformations");
      }).catch(error_0 => {
        addToast("error", error_0?.response?.data?.message || "Failed to delete transformation");
      }), _temp, {
        danger: true,
        title: "Delete transformation",
        submit_label: "Delete",
        cancel_label: "Keep transformation",
        message: <ConfirmDeleteDialog text="Deleted transformations cannot be recovered. Are you sure you'd like to proceed?" />
      });
    };
    $[27] = HookdeckAPI.transformations;
    $[28] = addToast;
    $[29] = history;
    $[30] = mutate_transformations;
    $[31] = showDialog;
    $[32] = transformation_id;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const onDelete = t13;
  let t14;
  if ($[34] !== updateSearchQuery) {
    t14 = selected_execution_id_0 => {
      updateSearchQuery({
        selected_execution_id: selected_execution_id_0
      });
    };
    $[34] = updateSearchQuery;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  const handleExecutionSelected = t14;
  let t15;
  if ($[36] !== updateSearchQuery) {
    t15 = pagination => {
      updateSearchQuery({
        ...pagination,
        selected_execution_id: undefined
      });
    };
    $[36] = updateSearchQuery;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  const handlePaginationChanged = t15;
  let t16;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      label: "Transformations",
      to: "/transformations"
    };
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  const t17 = transformation?.name || transformation_id;
  let t18;
  if ($[39] !== t17) {
    t18 = <ViewBreadcrumbsTitle breadcrumbs={[t16, {
      label: t17,
      highlight: true
    }]} />;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== is_executions_tab || $[42] !== refresh) {
    t19 = is_executions_tab && <Button outline={true} icon="reload" onClick={() => refresh()}>Refresh</Button>;
    $[41] = is_executions_tab;
    $[42] = refresh;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== transformation_id) {
    t20 = <Button to={location_0 => `/transformations/${transformation_id}/edit${location_0.search}`} outline={true} icon="edit">Edit transformation</Button>;
    $[44] = transformation_id;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t19 || $[47] !== t20) {
    t21 = <StyledViewNavActions>{t19}{t20}</StyledViewNavActions>;
    $[46] = t19;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t18 || $[50] !== t21) {
    t22 = <StyledViewNavHeader>{t18}{t21}</StyledViewNavHeader>;
    $[49] = t18;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== TABS) {
    t23 = Object.values(TABS);
    $[52] = TABS;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== current_tab || $[55] !== t23) {
    t24 = <StyledViewNavSecondary><Tabs active_tab={current_tab} border={false} tabs={t23} /></StyledViewNavSecondary>;
    $[54] = current_tab;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t22 || $[58] !== t24) {
    t25 = <StyledViewNav>{t22}{t24}</StyledViewNav>;
    $[57] = t22;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== disable_delete || $[61] !== handleExecutionSelected || $[62] !== handlePaginationChanged || $[63] !== is_executions_tab || $[64] !== onDelete || $[65] !== selected_execution_id || $[66] !== transformation || $[67] !== transformation_id) {
    t26 = is_executions_tab ? <TransformationExecutions transformation_id={transformation_id} selected_execution_id={selected_execution_id} onExecutionSelected={handleExecutionSelected} onPaginationChanged={handlePaginationChanged} /> : <TransformationOverview transformation={transformation} disable_delete={disable_delete} onDelete={onDelete} />;
    $[60] = disable_delete;
    $[61] = handleExecutionSelected;
    $[62] = handlePaginationChanged;
    $[63] = is_executions_tab;
    $[64] = onDelete;
    $[65] = selected_execution_id;
    $[66] = transformation;
    $[67] = transformation_id;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] !== t25 || $[70] !== t26) {
    t27 = <StyledViewContent>{t25}{t26}</StyledViewContent>;
    $[69] = t25;
    $[70] = t26;
    $[71] = t27;
  } else {
    t27 = $[71];
  }
  let t28;
  if ($[72] !== selected_execution_id || $[73] !== transformation_id || $[74] !== updateSearchQuery) {
    t28 = selected_execution_id && <TransformationExecutionDetails transformation_id={transformation_id} execution_id={selected_execution_id} onClose={() => updateSearchQuery({
      selected_execution_id: undefined
    })} />;
    $[72] = selected_execution_id;
    $[73] = transformation_id;
    $[74] = updateSearchQuery;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  let t29;
  if ($[76] !== t27 || $[77] !== t28) {
    t29 = <StyledViewLayout>{t27}{t28}</StyledViewLayout>;
    $[76] = t27;
    $[77] = t28;
    $[78] = t29;
  } else {
    t29 = $[78];
  }
  return t29;
};
const TransformationEditWrapper: React.FC = () => {
  const $ = _c(24);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    transformation_id
  } = useParams();
  const history = useHistory();
  const location = useLocation();
  let t0;
  if ($[0] !== transformation_id) {
    t0 = APIMethodKeys.transformations.get(transformation_id);
    $[0] = transformation_id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== HookdeckAPI.transformations || $[3] !== transformation_id) {
    t1 = () => HookdeckAPI.transformations.get(transformation_id);
    $[2] = HookdeckAPI.transformations;
    $[3] = transformation_id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: transformation,
    mutate
  } = useSWR(t0, t1);
  let t2;
  if ($[5] !== HookdeckAPI.transformations || $[6] !== mutate || $[7] !== transformation_id) {
    t2 = v => HookdeckAPI.transformations.update(transformation_id, {
      ...v.transformation,
      env: v.transformation.env.reduce(_temp2, {})
    }).then(transformation_0 => mutate(transformation_0));
    $[5] = HookdeckAPI.transformations;
    $[6] = mutate;
    $[7] = transformation_id;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const onSave = t2;
  if (!transformation) {
    return null;
  }
  let t3;
  if ($[9] !== history || $[10] !== location.state?.from || $[11] !== transformation_id) {
    t3 = () => {
      if (location.state?.from) {
        history.push(location.state?.from);
      } else {
        history.push(`/transformations/${transformation_id}`);
      }
    };
    $[9] = history;
    $[10] = location.state?.from;
    $[11] = transformation_id;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const t4 = transformation.name;
  const t5 = transformation.code;
  let t6;
  if ($[13] !== transformation.env) {
    t6 = Object.entries(transformation.env || {});
    $[13] = transformation.env;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = t6 as any;
  let t8;
  if ($[15] !== t7 || $[16] !== transformation.code || $[17] !== transformation.name) {
    t8 = {
      name: t4,
      code: t5,
      env: t7
    };
    $[15] = t7;
    $[16] = transformation.code;
    $[17] = transformation.name;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== onSave || $[20] !== t3 || $[21] !== t8 || $[22] !== transformation_id) {
    t9 = <TransformRuleFormWrapper onSave={onSave} onClose={t3} transformation_id={transformation_id} transformation={t8} />;
    $[19] = onSave;
    $[20] = t3;
    $[21] = t8;
    $[22] = transformation_id;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
const TransformationViewRouter: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Switch><Route path="/transformations/:transformation_id/edit*" component={TransformationEditWrapper} /><Route exact={true} path="/transformations/:transformation_id/executions/all" render={_temp3} /><Route path="/transformations/:id" component={TransformationView} /></Switch>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default TransformationViewRouter;
function _temp() {
  return null;
}
function _temp2(object, t0) {
  const [key, value] = t0;
  return {
    ...object,
    [key]: value
  };
}
function _temp3(t0) {
  const {
    match,
    history,
    location
  } = t0;
  return <TransformationExecutionsView transformation_id={match.params.transformation_id} onEdit={execution => history.push({
    ...location,
    search: execution ? `?input_execution_id=${execution.id}` : "",
    pathname: `/transformations/${match.params.transformation_id}/edit`,
    state: {
      from: location.pathname
    }
  })} onClose={() => {
    history.push(`/transformations/${match.params.transformation_id}`);
  }} />;
}